import "./nav-list.styles.css";

import translations from "../../translate"; // اضافه کردن فایل ترجمه

const NavList = ({ language }) => {
  const NAV_ITEMS = [
    {
      title: translations[language].navItems.home,
      link: "/",
      isFullWidth: false,
      submenu: [
        // { title: 'Welcome', link: '/home/welcome' },
        // { title: 'About Us', link: '/home/about' },
        // { title: 'Contact', link: '/home/contact' },
      ],
    },
    {
      title: translations[language].navItems.drop,
      link: "/drop",
      isFullWidth: false,
      submenu: [
        // { title: 'About Page', link: '/pages/about' },
        // { title: 'FAQ', link: '/pages/faq' },
        // { title: 'Pricing', link: '/pages/pricing' },
      ],
    },
    {
      title: translations[language].navItems.shop,
      link: "/shop-page",
      isFullWidth: true, // مگا منوی Shop باید تمام عرض باشد
      submenu: [
        // { title: 'Products', link: '/shop/products' },
        // { title: 'Cart', link: '/shop/cart' },
        // { title: 'Checkout', link: '/shop/checkout' },
        // { title: 'New Arrivals', link: '/shop/new-arrivals' },
        // { title: 'Best Sellers', link: '/shop/best-sellers' },
      ],
    },
  ];

  return (
    <ul className="nav-list">
      {NAV_ITEMS.map((item, index) => (
        <li key={index} className="nav-item">
          <a href={item.link} className="nav-link">
            {item.title}
          </a>
          <div className={`mega-menu ${item.isFullWidth ? "full-width" : ""}`}>
            <div className="mega-menu-content">
              {item.submenu.map((subItem, subIndex) => (
                <a key={subIndex} href={subItem.link} className="submenu-item">
                  {subItem.title}
                </a>
              ))}
            </div>
          </div>
        </li>
      ))}
    </ul>
  );
};

export default NavList;
